import { store } from '../../../store'
import { MessageDataType } from '../types'
import { updateSpotMatchRecordAction } from '../../../store/spot/actions'
import { SpotMatchRecord } from '../../../api/v1/spot'
import { WsOrderMessage } from './orders'

export type WsSpotMatchRecord = SpotMatchRecord & {
  tradeType: 'SPOTS'
}

export function onMessageSpotMatch(data: MessageDataType) {
  switch (data.type) {
    // Receive self user order matching data,
    // used to display in the 'Spot/UserOrders/TradeHistory' component
    case 'order_matched':
      updateMatch(data as WsOrderMessage<WsSpotMatchRecord>)
      break
  }
}

function updateMatch(data: WsOrderMessage<WsSpotMatchRecord>) {
  if (data.data.tradeType === 'SPOTS') {
    store.dispatch(
      updateSpotMatchRecordAction(data as WsOrderMessage<SpotMatchRecord>)
    )
  }
}
